module.exports = __webpack_public_path__ + "img/spin_btn.6e5e567f.png";